/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable camelcase */
import React, { useContext, useEffect, useState } from 'react'

import { mpfAuthCrudHttp } from '../../../../assets/ts/api/mpf-auth-crud-http'
import { mpfRListsHttp } from '../../../../assets/ts/api/mpf-r-lists-http'
import { mpfWhoHttp } from '../../../../assets/ts/api/mpf-who-http'
import { convertDate } from '../../../../assets/ts/date-and-time/date-and-time'
import Accordions from '../../../../components/accordions/accordions'
import Buttons from '../../../../components/buttons/buttons'
import PageOverlayBusy from '../../../../components/page-overlay/page-overlay-busy'
import usePascodeMetadata from '../../../../hooks/use-pascode-metadata'
import useUserProfile from '../../../../hooks/use-user-profile'
import { SettingsHeader } from '../../../../layouts/header/settings-header'
import { MetadataContext } from '../../../../store/metadata-context-provider'
import { RoleContext } from '../../../../store/role-context-provider'
import { UserContext } from '../../../../store/user-context-provider'
import { ALL_SELECT_OPTION, ALL_SELECT_OPTION_STRING } from '../../../../utils/constants/global-constants'
import CustomSelect from '../../../../utils/controls/custom-select'
import {
  AssignedComponent,
  Section,
  ServicingMAJCOM,
} from '../../../../utils/controls/select-options-data'
import AddEditView from './add-edit-view'
import PmgFolders from './pmg-folders'
import PmgData from './pmgdata'

const LIST_NAME = 'PolicyMemoAndGuidelinesList'

const SettingsPMG = ({
  assignedComponentOptions,
  initialMajcomOptions,
  initialSectionOptions,
  roleContext,
  visibleSquadrons,
}: any) => {
  const { userProfile } = useUserProfile()
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [showEdit, setShowEdit] = useState(false)
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [showAddPopup, setshowAddPopup] = useState(false)
  const [showAddEdit, setShowAddEdit] = useState(false)
  const [addFolderFile, setAddFolderFile] = useState(false)
  const [addFile, setAddFile] = useState(false)
  const [addFolder, setAddFolder] = useState(false)
  const [editFolder, setEditFolder] = useState(false)
  const [folderName, setFolderName] = useState(false)

  const [fetchFiles, setFetchFiles] = useState<boolean>(false)
  const [isLoaded, setIsLoaded] = useState<boolean>(false)

  const [policyMemoFolders, setPoliceMemoFolders] = useState<any[]>([])
  const [inputValues, setInputValues] = useState<any>({
    assignedComponentCode: -1,
    majcom: '',
  })

  const { pascodeMetadata } = usePascodeMetadata({
    IsArchived: false,
  })
  const { components, majcoms, sections } = useContext(MetadataContext)
  const [majcomOptions, setMajcomOptions] = useState<any[]>([])
  const [squadrons, setSquadrons] = useState<any[]>([])
  const [filteredSquadrons, setFilteredSquadrons] = useState<any[]>([])
  const [alert, setAlert] = useState<boolean>(true)
  useEffect(() => {
    setMajcomOptions(initialMajcomOptions.map(item =>({
       ...item,
      label : item.label,
      value :  item.label
    })))
  }, [initialMajcomOptions])

  useEffect(() => {
    if (assignedComponentOptions.length > 0 &&
      majcomOptions.length > 0 && !isLoaded) {
      setInputValues({
        assignedComponentCode: assignedComponentOptions[0].value,
        majcom: majcomOptions[0].value
      })
      setIsLoaded(true)
    }
  }, [assignedComponentOptions, majcomOptions])

  useEffect(() => {

    if (pascodeMetadata.length > 0) {
      const tempSquadrons: any[] = []

      pascodeMetadata.forEach((pascode) => {
        tempSquadrons.push({
          assignedComponent: pascode?.AssignedComponentCode,
          majcom: pascode?.ServicingMAJCOM,
          title: pascode?.ServicingOrganization
        })
      })


      const squadData = [...Object.values(tempSquadrons.reduce((acc, obj) => ({
        ...acc,
        [obj.title]: obj
      }), {}))]

      setSquadrons(squadData)
      setFilteredSquadrons(squadData)
    }
  }, [pascodeMetadata])

  useEffect(() => {
    const pmgData: any = []
    if (sections?.length > 0) {

      getFiles().then((files) => {

        filteredSquadrons.forEach((squadron: any) => {
          let containsSquadron = false
          Object.keys(visibleSquadrons).forEach((key) => {
            if (visibleSquadrons[key].length > 0) {
              const formattedSquadron: string = !isNaN(squadron?.title?.split(' ')[0])
                ? squadron.title.replace('MPF', 'FSS')
                : squadron.title

              if (visibleSquadrons[key].includes(formattedSquadron) ||
                visibleSquadrons[key]
                  .some((e) => e.squadron === formattedSquadron) ||
                visibleSquadrons[key].includes(squadron?.majcom) ||
                (visibleSquadrons.ACOwner.includes(
                  squadron?.assignedComponent
                ))) {
                containsSquadron = true
              }
            }
          })

          if (containsSquadron || roleContext?.isCPOwner) {
            const sectionData: any = []
            sections.forEach((section: any) => {
              let containsSection = false
              Object.keys(visibleSquadrons).forEach((key) => {
                if (key === 'SectionChief' || key === 'SectionOwner') {
                  const formattedSquadron: string = !isNaN(squadron?.title?.split(' ')[0])
                    ? squadron.title.replace('MPF', 'FSS')
                    : squadron.title

                  if (visibleSquadrons[key]
                    .some((e) => e.section === section.ShortName &&
                      e.squadron === formattedSquadron) &&
                    initialSectionOptions.some((e) => {
                      return e.value === section.SectionCode && e.squadron === formattedSquadron
                    }
                    )) {
                    containsSection = true
                  }
                } else {
                  containsSection = false
                }
              })

              if (containsSection ||
                roleContext?.isCPOwner ||
                roleContext?.isLeadership ||
                roleContext?.isMPFOwner ||
                roleContext?.isMAJCOMOwner ||
                roleContext?.isAssignedComponentOwner) {

                // gets files based on the squadron/section
                const sectionFiles = files[squadron.title] ?
                  files[squadron.title][section.Section] ?
                    files[squadron.title][section.Section]
                      .sort((a, b) =>
                        b.modifiedOn.localeCompare(a.modifiedOn)) : [] : []

                sectionData.push({
                  Created: sectionFiles.length > 0 ? sectionFiles[0].created : '',
                  Id: `${squadron.title}-${section.Section}`,
                  Modified: sectionFiles.length > 0 ? sectionFiles[0].modified : '',
                  Templates: section.Section,
                  files: sectionFiles,
                  modifiedOn: sectionFiles.length > 0 ? sectionFiles[0].modifiedOn : '',
                })
              }

            })
            pmgData.push({
              Created: sectionData.length > 0 ?
                sectionData[0].Created : '',
              Id: squadron.title,
              Modified: sectionData.length > 0 ?
                sectionData[0].Modified : '',
              Templates: squadron.title,
              folders: sectionData,
            })
          }
        })
        setPoliceMemoFolders(pmgData)
      })
    }
  }, [sections, filteredSquadrons, fetchFiles])

  useEffect(() => {
    if (policyMemoFolders.length > 0) setAlert(false)
  }, [policyMemoFolders])

  const getFiles = async () => {
    const files: any = {}
    const list = await mpfRListsHttp().getList(LIST_NAME)

    const listBlobs: any = await list.blobs().listAll()

    for (const blob of listBlobs) {
      for (const file of blob.blobs) {
        const squadron = file.folderName.split('/')[1]
        const section = file.folderName.split('/')[2]

        const createdBy: any = userProfile.find(
          (profile) => profile.UserRID === file.createdBy)

        const formattedCreateddBy = createdBy?.UserDisplayName
        const modifiedBy: any = userProfile.find(
          (profile) => profile.UserRID === file.modifiedBy)

        const formattedModifiedBy = modifiedBy?.UserDisplayName

        if (files[squadron]) {
          if (files[squadron][section]) {
            files[squadron][section].push({
              Id: file.eTag,
              created: `${formattedCreateddBy} | ${convertDate(file.createdOn, '')}`,
              createdBy: file.createdBy,
              eKey: file.eKey,
              folderName: file.folderName,
              metadata: file.metadata,
              modified: `${formattedModifiedBy} | ${convertDate(file.modifiedOn, '')}`,
              modifiedBy: file.modifiedBy,
              modifiedOn: file.modifiedOn,
              title: file.fileName
            })
          } else {
            files[squadron][section] = [({
              Id: file.eTag,
              created: `${formattedCreateddBy} | ${convertDate(file.createdOn, '')}`,
              createdBy: file.createdBy,
              eKey: file.eKey,
              folderName: file.folderName,
              metadata: file.metadata,
              modified: `${formattedModifiedBy} | ${convertDate(file.modifiedOn, '')}`,
              modifiedBy: file.modifiedBy,
              modifiedOn: file.modifiedOn,
              title: file.fileName
            })]
          }
        } else {
          files[squadron] = {
            [section]: [({
              Id: file.eTag,
              created: `${formattedCreateddBy} | ${convertDate(file.createdOn, '')}`,
              createdBy: file.createdBy,
              eKey: file.eKey,
              folderName: file.folderName,
              metadata: file.metadata,
              modified: `${formattedModifiedBy} | ${convertDate(file.modifiedOn, '')}`,
              modifiedBy: file.modifiedBy,
              modifiedOn: file.modifiedOn,
              title: file.fileName
            })]
          }
        }
      }
    }
    return files
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    setLoading(false)
  }, [])

  const [inEditMode, setInEditMode] = useState({
    rowKey: null,
    status: false,
  })
  const onCancel = () => {
    setInEditMode({
      rowKey: null,
      status: false,
    })
  }

  const onDelete = async (item: any, path: string) => {
    const list = await mpfRListsHttp().getList('PolicyMemoAndGuidelinesList')
    const pmgData: any = await list.query().filter(`Path eq '${path}'`).get()

    const listBlobs = await list.blobs()

    listBlobs.delete(
      pmgData[0].eKey as string,
      item.title,
      item.folderName,
      item.Id
    )
    setFetchFiles(!fetchFiles)
  }

  const onEdit = (item: any) => {
    setshowAddPopup(false)
    setInEditMode({
      rowKey: item.Id,
      status: true,
    })
    setFolderName(item?.Templates)
    setShowAddEdit(false)
    setEditFolder(true)
    setAddFile(false)
    setAddFolder(false)
    setAddFolderFile(false)
  }
  const onAccourdion = (item: any) => {
    setshowAddPopup(false)
  }

  const onAdd = (item: any) => {
    setInEditMode({
      rowKey: item.Id === inEditMode.rowKey ? null : item.Id,
      status: item.Id === inEditMode.rowKey ? false : true,
    })
  }

  const onAssignComponentChange = (e: any) => {
    const tempSquadrons = squadrons.filter((squadron) =>
      squadron.assignedComponent === e.value || e.value === -1
    )

    setFilteredSquadrons(tempSquadrons)

    const options = [
      ...pascodeMetadata
        .filter(
          (pascodeEntry: any) => {
            let containsSquadron = false

            Object.keys(visibleSquadrons).forEach((key) => {
              if (visibleSquadrons[key].length > 0) {
                const formattedSquadron: string = pascodeEntry?.ServicingOrganization.replace('MPF', 'FSS')
                if (visibleSquadrons[key].includes(formattedSquadron) ||
                  visibleSquadrons[key]
                    .some((e) => e.squadron === formattedSquadron) ||
                  (visibleSquadrons.ACOwner.includes(
                    pascodeEntry?.AssignedComponentCode
                  ))) {
                  containsSquadron = true
                }
              }
            })

            return (containsSquadron || roleContext?.isCPOwner) &&
              (e.value === -1 ||
                (pascodeEntry.AssignedComponentCode === e.value &&
                  pascodeEntry.ServicingMAJCOM !== null))
          }).map((majcomEntry: any) => ({
            label: majcomEntry.ServicingMAJCOM,
            value: majcomEntry.ServicingMAJCOM,
          })),
    ]


    const reducedOptions: any = [
      ...Object.values(
        options.reduce(
          (acc, obj) => ({
            ...acc,
            [obj.value]: obj,
          }),
          {}
        )
      ),
    ]

    if (reducedOptions.length > 1)
      reducedOptions.unshift(ALL_SELECT_OPTION_STRING)

    setMajcomOptions(reducedOptions)

    setInputValues({
      assignedComponentCode: e.value,
      majcom: reducedOptions[0]?.value || ''
    })
  }
  const onMAJCOMChange = (e: any) => {
    const tempSquadrons = squadrons.filter((squadron) =>
    ((squadron.assignedComponent === inputValues.assignedComponentCode ||
      inputValues.assignedComponentCode === -1) &&
      (e.value === 'All' || squadron.majcom === e.label))
    )

    setFilteredSquadrons(tempSquadrons)

    setInputValues({
      ...inputValues,
      majcom: e.label
    })
  }
  return (
    <div className='row m-0'>
      {alert && <PageOverlayBusy />}
      <SettingsHeader
        extras={
          <div className='d-flex align-items-center flex-wrap settingsfilters'>
            <div className='mx-2 my-sm-2'>
              <CustomSelect
                className='form-sm w-100 max-w-sm-200 min-w-sm-200  sourcesanspro font-13 customselect'
                formClassName='form-horizontal dash poppins-semibold font-11 title-color41 '
                id='AssignComponent'
                label='Assigned Component'
                name='Assigned Component'
                onChange={onAssignComponentChange}
                options={assignedComponentOptions}
                value={inputValues.assignedComponentCode}
              />
            </div>
            <div className='mx-2 my-sm-2'>
              <CustomSelect
                className='form-sm w-100 max-w-sm-100 min-w-sm-100  sourcesanspro font-13 customselect'
                formClassName='form-horizontal dash poppins-semibold font-11 title-color41 '
                id='ServicingMAJCOM'
                label='Servicing MAJCOM'
                name='Servicing MAJCOM'
                onChange={onMAJCOMChange}
                options={majcomOptions}
                value={inputValues.majcom}
              />
            </div>
            {/* <div className='dividerdashed vertical mx-1 mx-lg-2 d-none d-md-block'></div>
            <div className='d-flex ms-auto'>
              <div className='mx-1 my-sm-2'>
                <Buttons
                  aria-label='Add File'
                  className='btn-sm font-0 font-xl-13 btn-primary ms-auto whitetext text-nowrap border-radius poppins-bold'
                  icon='icon-add me-xl-1 font-11'
                  label='ADD FILE'
                  onClick={() => {
                    setShowAddEdit(true)
                    setAddFile(true)
                    setAddFolder(false)
                    setEditFolder(false)
                    setAddFolderFile(false)
                  }}
                />
              </div>

              <div className='mx-1 my-sm-2'>
                <Buttons
                  aria-label='Add Folder'
                  className='btn-sm font-0 font-xl-13 btn-primary ms-auto whitetext text-nowrap border-radius poppins-bold'
                  icon='icon-add me-xl-1 font-11'
                  label='ADD FOLDER'
                  onClick={() => {
                    setShowAddEdit(true)
                    setAddFolder(true)
                    setAddFile(false)
                    setEditFolder(false)
                    setAddFolderFile(false)
                  }}
                />
              </div>
            </div> */}
          </div>
        }
        name='Policy Memos & Guidelines'
      />

      <div className='p-0 settings-main mt-2 customaccrdionactive'>
        {/* {showAddEdit && (
          <AddEditView
            addFile={addFile}
            addFolder={addFolder}
            addFolderFile={addFolderFile}
            details={accordionsArray}
            editFolder={editFolder}
            filtersvalue={addeditValue}
            folderClose={addFolderClick}
            folderName={folderName}
            showAddEdit={showAddEdit}
          />
        )} */}
        <PmgFolders fetchFiles={fetchFiles}
          folders={policyMemoFolders}
          inEditMode={inEditMode}
          onAccourdion={onAccourdion}
          onAdd={onAdd}
          onCancel={onCancel}
          onDelete={onDelete}
          onEdit={onEdit}
          setFetchFiles={setFetchFiles}
          showAddEdit={showAddEdit}
        />
      </div>
    </div>
  )
}
export default SettingsPMG
